export const fundFilterCalculation = (
  acheiveBy,
  withdraw,
  risk,
  riskProfile
) => {
  const acheiveByResult = acheiveBy.points * (acheiveBy.weight / 100);
  const withdrawResult = withdraw.points * (withdraw.weight / 100);
  const riskByResult = risk.points * (risk.weight / 100);
  const riskProfileResult = riskProfile.points * (riskProfile.weight / 100);

  return acheiveByResult + withdrawResult + riskByResult + riskProfileResult;
};

export const fundFilterCalculationTFSA = (risk, riskProfile) => {
  const riskByResult = risk.points * (risk.weight / 100);
  const riskProfileResult = riskProfile.points * (riskProfile.weight / 100);

  return riskByResult + riskProfileResult;
};
